/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BikeBenefitOptionsDTO
 */
export interface BikeBenefitOptionsDTO {
    /**
     * 
     * @type {number}
     * @memberof BikeBenefitOptionsDTO
     */
    'employerGrant': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BikeBenefitOptionsDTO
     */
    'employerExtras': Array<BikeBenefitOptionsDTOEmployerExtrasEnum>;
    /**
     * 
     * @type {string}
     * @memberof BikeBenefitOptionsDTO
     */
    'platformName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BikeBenefitOptionsDTO
     */
    'platformUrl': string;
}

export const BikeBenefitOptionsDTOEmployerExtrasEnum = {
    Inspection: 'INSPECTION',
    Insurance: 'INSURANCE'
} as const;

export type BikeBenefitOptionsDTOEmployerExtrasEnum = typeof BikeBenefitOptionsDTOEmployerExtrasEnum[keyof typeof BikeBenefitOptionsDTOEmployerExtrasEnum];


